import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import {
	determineCancellationReasonModal,
	JourneySwitchModal,
} from '@acorn-portal/shared/src/pages/cancellation/utils/determine-cancellation-reason-modal';
import { useState } from 'react';
import MtaModal from './mta-modal';
import MtaVehicleModal from './mta-vehicle-modal';

/**
 * Modal selector component that displays on the CancellationDate page if alternatives to cancellation are possible
 */
const JourneySwitchModals = () => {
	const fullPolicy = useAppSelector((state) => state.fullPolicy);
	const cancellationState = useAppSelector((state) => state.cancellation);
	const reason = cancellationState.reasonForCancellation;
	const lastSubmittedReason = cancellationState.cancellationRatingCommand?.cancellationReason ?? '';
	const hasChangedReason = lastSubmittedReason !== reason;
	const [enableModals, setEnableModals] = useState(hasChangedReason); // if it's a newly selected reason, enable the modals
	const mtaPermitted = !!fullPolicy.mtaEligibility?.isEligible;
	let visibleModal: JourneySwitchModal = '';
	if (enableModals) {
		visibleModal = determineCancellationReasonModal(reason, mtaPermitted);
		return (
			<>
				{visibleModal === 'mta-vehicle' && (
					<MtaVehicleModal open={enableModals} onClose={() => setEnableModals(false)} stepNumber={2} />
				)}
				{visibleModal === 'mta' && (
					<MtaModal open={enableModals} onClose={() => setEnableModals(false)} stepNumber={2} />
				)}
			</>
		);
	} else return null;
};

export default JourneySwitchModals;
